import m from 'mithril';
import {trans, has_permission} from "./helpers";
import Typeahead from './typeaheadComponent.js';
import SelectTypeahead from './selectTypeaheadComponent.js';


let search_state = {
    page: 1,
    limit: 8,
    loading: false,
    challenges : {
        list : [],
        // query: '',
        timeout: null,
        load_more: false,
    },
    exercises : {
        list : [],
        // query: '',
        timeout: null,
        load_more: false,
    },
    groups: [],
    search_parameters: {}, // see function reset_search_parameters()
    entry_types: {
        list:[]
    },
    search_mode: 'challenges',
    // advanced_search: false,
    advanced_search: true,
    sst_mode: false,

    active_filter_list: [
        {
            id_filter: 1,
            code: 'active',
            title: trans('challenge.active_challenges'),
        },
        {
            id_filter: 2,
            code: 'past',
            title: trans('challenge.past_challenges'),
        }
    ]
};


function reset_search_parameters() {
    // search_state.advanced_search = false;

    search_state.search_parameters = {
        query: '',
        id_entry_type: 0,
        // id_sport: 0,
        // sport_text: null,
        groups: {},
        sports: {
            list: []
        },
        entry_types: {
            list: []
        },
        active_filter: {
            list: []
        }
    }

    search_state.groups.forEach(g => {
        if (!(g.code in search_state.search_parameters.groups)) {
            search_state.search_parameters.groups[g.code] = {
                id_group: g.id_group*1,
                list: []
            };
        }
    });
}

function get_groups() {
    m.request('/api/groups?part=items').then(d => {
        search_state.groups = d;

        search_state.groups.forEach(g => {
            if (!(g.code in search_state.search_parameters.groups)) {
                search_state.search_parameters.groups[g.code] = {
                    id_group: g.id_group*1,
                    list: []
                };
            }
        });

        let queryParams = new URLSearchParams(window.location.search);

        if (queryParams.get("age_groups")) {
            let age_groups_ids = queryParams.get("age_groups").split(',').map(id_group_item => id_group_item*1);

            search_state.groups.forEach(g => {
                let age_groups = g.items.filter(age_group => age_groups_ids.includes(age_group.id_group_item*1));

                search_state.search_parameters.groups[g.code]['list'] = age_groups;
            });

            get_data();
        }
        

    }).catch(err => {
        alert('Something went wrong, please refresh page.')
    })
}

class Challenges {
    view() {
        return [
            (search_state.challenges.list.length == 0 && !search_state.loading) &&
            m('.center-element', trans('common.no_results')),

            (search_state.challenges.list.length > 0) &&
            m('.item-grid', [
                search_state.challenges.list.map(challenge => {

                    return m('a.item-component', { href: '/challenge/view/' + challenge.slug }, [
                        challenge.url_poster &&
                        m('div.item-component__thumb', 
                            m('img', { src: challenge.url_poster })
                        ),

                        !challenge.url_poster &&
                        m('div.item-component__thumb', 
                            m('img', { src: '/imgs/default_thumb.jpg' })
                        ),

                        m('.item-component__title', challenge.title),
                        // m('.item-component__author', [
                        //     challenge.profile_picture_url &&
                        //     m('.avatar', 
                        //         m('img', { src: 'https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/' + challenge.profile_picture_url, alt: 'Profile image of ' + challenge.display_name  } )
                        //     ),

                        //     !challenge.profile_picture_url &&
                        //     m('.avatar', 
                        //         m('img', { src: 'https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/user_profile/default.jpg', alt: 'Profile image of ' + challenge.display_name })
                        //     ),

                        //     m('.item-component__author__name', challenge.display_name)
                        // ]),
                        m('.item-component__author', [
                            m.trust(challenge.inserted_at + '&nbsp; • &nbsp;' + trans('profile.entries') + ': ' + challenge.total_users) 
                        ]),
                    ])
                })
            ]),

            (search_state.challenges.load_more && !search_state.loading) &&
            m('.btn.btn--small.btn--full-width', { 
                onclick: e => load_more(e)
            }, trans('common.load_more')),
        ];
    }
}

class Exercises {
    view() {
        return [
            (search_state.exercises.list.length == 0 && !search_state.loading) &&
            m('.center-element', trans('common.no_results')),

            (search_state.exercises.list.length > 0) &&
            m('.item-grid', [
                search_state.exercises.list.map(exercise => {

                    return m('a.item-component', { href: '/exercise/view/' + exercise.slug }, [
                        exercise.url_poster &&
                        m('div.item-component__thumb', 
                            m('img', { src: exercise.url_poster })
                        ),

                        !exercise.url_poster &&
                        m('div.item-component__thumb', 
                            m('img', { src: '/imgs/default_thumb.jpg' })
                        ),

                        m('.item-component__title', exercise.title),
                        // m('.item-component__author', [
                        //     exercise.profile_picture_url &&
                        //     m('.avatar', 
                        //         m('img', { src: 'https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/' + exercise.profile_picture_url, alt: 'Profile image of ' + exercise.display_name  } )
                        //     ),

                        //     !exercise.profile_picture_url &&
                        //     m('.avatar', 
                        //         m('img', { src: 'https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/user_profile/default.jpg', alt: 'Profile image of ' + exercise.display_name })
                        //     ),

                        //     m('.item-component__author__name', exercise.display_name)
                        // ]),
                        m('.item-component__author', [
                            m.trust(exercise.inserted_at) 
                        ]),
                    ])
                })
            ]),

            (search_state.exercises.load_more && !search_state.loading) &&
            m('.btn.btn--small.btn--full-width', { 
                onclick: e => load_more(e)
            }, trans('common.load_more')),
        ];
    }
}

class ChallengesAdvancedFilters {
    getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&has_challenge=1&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    getSportTitle(sport) {
        // return Array((sport.depth*5)+1).join(`\u00A0`) + sport.title;
        return sport.title;
    }
    
    view() {
        return [
            m('.filters-row', [
                m('.one-filter', [
                    m('.filter-label', trans('challenge.individual_group_text')),
                    m(SelectTypeahead, {
                        listMode: true,
                        list: search_state.entry_types,
                        selectedItems: search_state.search_parameters.entry_types, // must be object with 'list' atribute (see function: get_groups())
                        placeholder: trans('common.all'),
                        noResultsText: trans('common.no_results'),
                        getItemText: et =>  trans('common.entry_types.' + et.code),
                        getItemId: et => et.id_entry_type,
                        onChange: _ => {
                            update_url_from_state()
                            get_data(true);
                        },
                        type: 'radio'
                    })
                ]),
                m('.one-filter', [
                    m('.filter-label', trans('common.sport')),
                    m(SelectTypeahead, {
                        listMode: false,
                        getData: this.getSportsData,
                        selectedItems: search_state.search_parameters.sports, // must be object with 'list' atribute (see function: get_groups())
                        // placeholder: trans('common.all'),
                        placeholder: trans('common.all_sports'),
                        noResultsText: trans('common.no_results'),
                        getItemText: this.getSportTitle,
                        getItemId: s => s.id_sport,
                        onChange: _ => {
                            update_url_from_state()
                            get_data(true);
                        }
                    })
                ]),
                m('.one-filter', [
                    search_state.groups.map(g => {
                        return [
                            m('.filter-label', g.title),
                            search_state.search_parameters.groups[g.code] &&
                            m(SelectTypeahead, {
                                listMode: true,
                                list: g.items,
                                selectedItems: search_state.search_parameters.groups[g.code], // must be object with 'list' atribute (see function: get_groups())
                                placeholder: trans('common.all'),
                                noResultsText: trans('common.no_results'),
                                getItemText: i => i.title,
                                getItemId: i => i.id_group_item,
                                onChange: _ => {
                                    update_url_from_state()
                                    get_data(true);
                                }
                                // onClose: _ => get_data(true) // USE THIS TO GET DATA WHEN YOU CLOSE THE TYPEAHEAD
                            })
                        ]
                    })
                ]),
            ]),
        ];
    }
}

class ExercisesAdvancedFilters {
   getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&has_exercise=1&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    getSportTitle(sport) {
        // return Array((sport.depth*5)+1).join(`\u00A0`) + sport.title;
        return sport.title;
    }
    
    view() {
        return [
            m('.filters-row', [
                m('.one-filter', [
                    m('.filter-label', trans('common.sport')),
                    m(SelectTypeahead, {
                        listMode: false,
                        getData: this.getSportsData,
                        selectedItems: search_state.search_parameters.sports, // must be object with 'list' atribute (see function: get_groups())
                        // placeholder: trans('common.all'),
                        placeholder: trans('common.all_sports'),
                        noResultsText: trans('common.no_results'),
                        getItemText: this.getSportTitle,
                        getItemId: s => s.id_sport,
                        onChange: _ =>  {
                            update_url_from_state()
                            get_data(true);
                        }
                    })
                ]),
                m('.one-filter', [
                    search_state.groups.map(g => {
                        return [
                            m('.filter-label', g.title),
                            search_state.search_parameters.groups[g.code] &&
                            m(SelectTypeahead, {
                                listMode: true,
                                list: g.items,
                                selectedItems: search_state.search_parameters.groups[g.code], // must be object with 'list' atribute (see function: get_groups())
                                placeholder: trans('common.all'),
                                noResultsText: trans('common.no_results'),
                                getItemText: i => i.title,
                                getItemId: i => i.id_group_item,
                                onChange: _ => {
                                    update_url_from_state()
                                    get_data(true);
                                }
                                // onClose: _ => get_data(true) // USE THIS TO GET DATA WHEN YOU CLOSE THE TYPEAHEAD
                            })
                        ]
                    })
                ]),
            ]),
        ];
    }
}

class SSTFilters {
    query_challenges(e) {
        search_state.search_parameters.query = e.target.value;

        clearTimeout(search_state.challenges.timeout);

        search_state.challenges.timeout = setTimeout(e => {
            search_state.page = 1;
            search_state.load_more = false;
            get_data();
        }, 500);
    }

    getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&has_sst_challenge=1&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    getSportTitle(sport) {
        // return Array((sport.depth*5)+1).join(`\u00A0`) + sport.title;
        return sport.title;
    }


    view() {
        // console.log(search_state.entry_types);
        
        return m('.component--filters', [
            m('.filters-row', [
                m('.one-filter', [
                    m('.filter-label', trans('common.search')),

                    m('input', {
                        placeholder: trans('challenge.select_challenge_placeholder'),
                        type: 'text',
                        // value: search_state.search_parameters.query,
                        onkeyup: e => this.query_challenges(e)
                    }),
                ]),
            ]),

            m('.filters-row', [
                m('.one-filter', [
                    m('.filter-label', trans('challenge.individual_group_text')),
                    m(SelectTypeahead, {
                        listMode: true,
                        list: search_state.entry_types,
                        selectedItems: search_state.search_parameters.entry_types, // must be object with 'list' atribute (see function: get_groups())
                        placeholder: trans('common.all'),
                        noResultsText: trans('common.no_results'),
                        getItemText: et =>  trans('common.entry_types.' + et.code),
                        getItemId: et => et.id_entry_type,
                        onChange: _ => get_data(true),
                        type: 'radio'
                    })
                ]),
                m('.one-filter', [
                    m('.filter-label', trans('challenge.active_past_text')),
                    m(SelectTypeahead, {
                        listMode: true,
                        list: search_state.active_filter_list,
                        selectedItems: search_state.search_parameters.active_filter, // must be object with 'list' atribute (see function: get_groups())
                        placeholder: trans('common.all'),
                        noResultsText: trans('common.no_results'),
                        getItemText: f =>  f.title,
                        getItemId: f => f.id_filter,
                        onChange: _ => get_data(true),
                        type: 'radio'
                    })
                ]),
                m('.one-filter', [
                    m('.filter-label', trans('common.sport')),
                    m(SelectTypeahead, {
                        listMode: false,
                        getData: this.getSportsData,
                        selectedItems: search_state.search_parameters.sports, // must be object with 'list' atribute (see function: get_groups())
                        // placeholder: trans('common.all'),
                        placeholder: trans('common.all_sports'),
                        noResultsText: trans('common.no_results'),
                        getItemText: this.getSportTitle,
                        getItemId: s => s.id_sport,
                        onChange: _ => get_data(true)
                    })
                ]),
                m('.one-filter', [
                    search_state.groups.map(g => {
                        return [
                            m('.filter-label', g.title),
                            search_state.search_parameters.groups[g.code] &&
                            m(SelectTypeahead, {
                                listMode: true,
                                list: g.items,
                                selectedItems: search_state.search_parameters.groups[g.code], // must be object with 'list' atribute (see function: get_groups())
                                placeholder: trans('common.all'),
                                noResultsText: trans('common.no_results'),
                                getItemText: i => i.title,
                                getItemId: i => i.id_group_item,
                                onChange: _ => get_data(true)
                                // onClose: _ => get_data(true) // USE THIS TO GET DATA WHEN YOU CLOSE THE TYPEAHEAD
                            })
                        ]
                    })
                ]),
            ])
        ]);
    }
}

class ChallengeSearcher {
    oninit() {
        
    }

    query_challenges(e) {
        search_state.search_parameters.query = e.target.value;

        clearTimeout(search_state.challenges.timeout);

        search_state.challenges.timeout = setTimeout(e => {
            search_state.page = 1;
            search_state.load_more = false;

            update_url_from_state();

            get_data();
        }, 500);
    }

    query_exercises(e) {
        search_state.search_parameters.query = e.target.value;

        clearTimeout(search_state.exercises.timeout);

        search_state.exercises.timeout = setTimeout(e => {
            search_state.page = 1;
            search_state.load_more = false;
            
            update_url_from_state();
            
            get_data();
        }, 500);
    }

    change_search_mode(mode) {
        search_state.search_mode = mode;
        search_state.page = 1;

        update_url_from_state();

        get_data(true);
    }

    view() {
        let query_input_placeholder = trans('challenge.select_challenge_placeholder');

        if (search_state.search_mode == 'exercises')
            query_input_placeholder = trans('challenge.select_exercise_placeholder');

        return [
            !search_state.sst_mode &&
            m('.component--filters', [
                m('.filters-row', [
                    m('.one-filter', [
                        m('.filter-label', trans('challenge.search_for')),
                        m('.ButtonsSelect', [
                            m('.opt' + (search_state.search_mode == 'challenges' ? '.active' : ''), {
                                onclick: e => this.change_search_mode('challenges')
                            }, trans('challenge.title')),
                            m('.opt' + (search_state.search_mode == 'exercises' ? '.active' : ''), {
                                onclick: e => this.change_search_mode('exercises')
                            }, trans('exercises.title')),
                        ])
                    ]),
                    m('.one-filter', [
                        m('.filter-label', trans('common.search')),

                        m('input', {
                            placeholder: query_input_placeholder,
                            type: 'text',
                            value: search_state.search_parameters.query,
                            onkeyup: e => {
                                if (search_state.search_mode == 'challenges')
                                    this.query_challenges(e)
                                if (search_state.search_mode == 'exercises')
                                    this.query_exercises(e)
                            }
                        })
                    ]),
                ]),

                (search_state.advanced_search && search_state.search_mode == 'challenges') &&
                m(ChallengesAdvancedFilters),
                
                (search_state.advanced_search && search_state.search_mode == 'exercises') &&
                m(ExercisesAdvancedFilters)
            ]),

            (!search_state.advanced_search && !search_state.sst_mode) &&
            m('.advanced-search', {
                onclick: e => {
                    search_state.advanced_search = true;
                }
            }, '+ ' + trans('challenge.advanced_search')),

            search_state.sst_mode &&
            m(SSTFilters),

            (search_state.search_mode == 'challenges') &&
            m(Challenges),

            (search_state.search_mode == 'exercises') &&
            m(Exercises),

            search_state.loading &&
            m('.general-loader', '')
            // m('div.center-element', trans('challenge.loading') + '...')
        ]
    }
}

function load_more(e) {
    search_state.page = search_state.page+1;
    search_state.load_more = false;
    get_data(false);
}

function get_group_items_ids() {
    let group_items = [];

    for (let key in search_state.search_parameters.groups) {
        let group = search_state.search_parameters.groups[key];

        for (let i in group.list)
            group_items.push(group.list[i]);
    }

    let group_item_ids = group_items.map(i => i.id_group_item*1);

    return group_item_ids;
}

function get_data(override=true) {
    if (override) {
        search_state.page = 1;
    }

    if (search_state.search_mode == 'challenges') {
        get_challenges(override);
    }

    if (search_state.search_mode == 'exercises') {
        get_exercises(override);
    }
}

function get_challenges(override=true) {
    search_state.loading = true;
    search_state.challenges.load_more = false;

    m.redraw();

    let query_parameters = 'part=exercises' + 
                           '&page=' + search_state.page +
                           '&limit=' + search_state.limit +
                           '&visibility=public' +
                           '&my_organization=true' +
                           '&order_by=inserted_at|desc' + 
                           '&is_on_program=0' + 
                           '&query='+search_state.search_parameters.query;

    if (search_state.search_parameters.entry_types.list.length > 0) {
        query_parameters += '&id_entry_type=' + search_state.search_parameters.entry_types.list[0].id_entry_type;
    }

    if (search_state.search_parameters.active_filter.list.length > 0) {
        query_parameters += '&filter_active=' + search_state.search_parameters.active_filter.list[0].code;
    }

    let group_item_ids_str = get_group_items_ids().join(',');

    if (group_item_ids_str.length > 0) {
        query_parameters += '&group_item_ids=' + group_item_ids_str;
    }

    let sport_ids_str = search_state.search_parameters.sports.list.map(s => s.id_sport).join(',');

    if (sport_ids_str.length > 0) {
        query_parameters += '&sport_ids=' + sport_ids_str;
    }


    if (search_state.sst_mode) {
        query_parameters += '&is_sst=1';
    }

    if (has_permission('challenges.canViewBySport')) {
        query_parameters += '&view_by_my_sports=1';
    }

    if (has_permission('challenges.canViewByRegion')) {
        query_parameters += '&view_by_my_regions=1';
    }

    m.request('/api/challenge?' + query_parameters)
        .then(d => {
            search_state.challenges.load_more = false;
            
            if (d.length > search_state.limit) {
                search_state.challenges.load_more = true;
                d = d.slice(0, search_state.limit);
            }

            d = d.map(challenge => {
                challenge['inserted_at'] = new Date(challenge['inserted_at']).toLocaleDateString("sl-SI");
                return challenge;
            });            


            if (override) {
                search_state.challenges.list = d;                
            } else {
                search_state.challenges.list = search_state.challenges.list.concat(d);
            }


            search_state.loading = false;
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function get_exercises(override=true) {
    search_state.loading = true;
    search_state.exercises.load_more = false;

    m.redraw();

    let query_parameters = 'visibility=public' + 
                           '&page=' + search_state.page +
                           '&limit=' + search_state.limit +
                           '&visibility=public' +
                           '&order_by=inserted_at|desc' + 
                           '&query='+search_state.search_parameters.query;

    let group_item_ids_str = get_group_items_ids().join(',');

    if (group_item_ids_str.length > 0) {
        query_parameters += '&group_item_ids=' + group_item_ids_str;
    }

    let sport_ids_str = search_state.search_parameters.sports.list.map(s => s.id_sport).join(',');

    if (sport_ids_str.length > 0) {
        query_parameters += '&sport_ids=' + sport_ids_str;
    }


    m.request('/api/exercises?' + query_parameters)
        .then(d => {
            search_state.exercises.load_more = false;

            if (d.length > search_state.limit) {
                search_state.exercises.load_more = true;
                d = d.slice(0, search_state.limit);
            }

            d = d.map(exercise => {
                exercise['inserted_at'] = new Date(exercise['inserted_at']).toLocaleDateString("sl-SI");
                return exercise;
            });            


            if (override) {
                search_state.exercises.list = d;                
            } else {
                search_state.exercises.list = search_state.exercises.list.concat(d);
            }


            search_state.loading = false;
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function get_entry_types() {
    if (search_state.entry_types.list.length == 0) {
        m.request('/api/entry_types').then(d => {
            search_state.entry_types.list = d.feed;

            let queryParams = new URLSearchParams(window.location.search);

            if (queryParams.get("entry_type")) {
                let entry_type = search_state.entry_types.list.filter(entry_type => entry_type.id_entry_type*1 == queryParams.get("entry_type")*1);
                entry_type = entry_type.length > 0 ? entry_type[0] : false;

                if (entry_type)
                    search_state.search_parameters.entry_types.list = d.feed.filter(_entry_type => _entry_type.id_entry_type == entry_type.id_entry_type);
                
                get_data();
            }

        }).catch(err => {
            alert('Something went wrong, please refresh page.')
        })
    }
}


function check_mode(mode) {
    if (mode == 'sst') {
        search_state.sst_mode = true;
    }
}

function update_url_from_state() {
    let queryParams = new URLSearchParams(window.location.search);

    queryParams.set("search_mode", search_state.search_mode);
    queryParams.set("query", search_state.search_parameters.query);
    queryParams.set("sports", search_state.search_parameters.sports.list.map(sport => sport.id_sport));
    queryParams.set("entry_type", search_state.search_parameters.entry_types.list.map(entry_type => entry_type.id_entry_type));
    
    let age_groups = search_state.groups.filter(group => group.id_group*1 == 1); //age groups
    if (age_groups.length > 0) {
        queryParams.set("age_groups", search_state.search_parameters.groups[age_groups[0].code].list.map(group_item => group_item.id_group_item));
    }

     // if (queryParams.get("age_groups")) {
     //        let age_groups_ids = queryParams.get("age_groups").split(',').map(id_group_item => id_group_item*1);

     //        search_state.groups.forEach(g => {
     //            let age_groups = g.items.filter(age_group => age_groups_ids.includes(age_group.id_group_item*1));

     //            search_state.search_parameters.groups[g.code]['list'] = age_groups;
     //        });

     //        get_data();
     //    }

    history.replaceState(null, null, "?"+queryParams.toString());
}

function set_state_from_url() {
    let queryParams = new URLSearchParams(window.location.search);

    let accepted_search_modes = ['challenges', 'exercises'];

    if (queryParams.get("search_mode")) {
        let search_mode = accepted_search_modes.includes(queryParams.get("search_mode")) ? queryParams.get("search_mode") : "challenges"; 
        search_state.search_mode = search_mode;
    }

    if (queryParams.get("query")) {
        search_state.search_parameters.query = queryParams.get("query");
    }

    if (queryParams.get("sports")) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&has_exercise=1&id_sports="+queryParams.get("sports"),
        }).then(function(data) {
            search_state.search_parameters.sports.list = data;
            get_data();
            // search_state.search_parameters.query = queryParams.get("query");
            // data_state.results = data;
            // data_state.is_loading = false;
        });
    }
    // search_state.entry_types
    // console.log(search_state.entry_types);
       // g.items

    // get_data();
}

function init(rootElement, mode='default', default_view='challenges') {
    if (!rootElement) {
        return;
    }

    reset_search_parameters();

    check_mode(mode);

    search_state.search_mode = default_view;

    set_state_from_url();

    get_data();
    get_entry_types();
    get_groups();

    m.mount(rootElement, ChallengeSearcher);
}

export default init;
